import { render, staticRenderFns } from "./WordCloudDetail.vue?vue&type=template&id=17641a6e&scoped=true&"
import script from "./WordCloudDetail.vue?vue&type=script&lang=js&"
export * from "./WordCloudDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17641a6e",
  null
  
)

export default component.exports